export type EndUserPayoutSetupSteps = {
  payoutConsentAccepted: boolean;
  kycStatus: boolean;
  payoutStatus: boolean;
};

export type EndUserDashboardSteps = {
  payoutSetup: EndUserPayoutSetupSteps;
  bankingConsentAccepted: boolean;
  payrollDeductionConsentAccepted: boolean;
};

export const EMPTY_END_USER_DASHBOARD_STEPS: EndUserDashboardSteps = {
  payoutSetup: {
    payoutConsentAccepted: false,
    kycStatus: false,
    payoutStatus: false,
  },
  bankingConsentAccepted: false,
  payrollDeductionConsentAccepted: false,
};

export function normalizeEndUserDashboardSteps(
  steps: Partial<EndUserDashboardSteps> | null | undefined
): EndUserDashboardSteps {
  const payoutSetup = steps?.payoutSetup;

  return {
    payoutSetup: {
      payoutConsentAccepted: payoutSetup?.payoutConsentAccepted === true,
      kycStatus: payoutSetup?.kycStatus === true,
      payoutStatus: payoutSetup?.payoutStatus === true,
    },
    bankingConsentAccepted: steps?.bankingConsentAccepted === true,
    payrollDeductionConsentAccepted: steps?.payrollDeductionConsentAccepted === true,
  };
}

export function areEndUserDashboardStepsComplete(steps: EndUserDashboardSteps): boolean {
  return (
    steps.payoutSetup.payoutConsentAccepted &&
    steps.payoutSetup.kycStatus &&
    steps.payoutSetup.payoutStatus &&
    steps.bankingConsentAccepted &&
    steps.payrollDeductionConsentAccepted
  );
}
